import axiosInstance from '../axiosInstance';

export const getQnaCategories = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/qna/category', {
      params,
    });
    return response.data.data;
  } catch (error) {
    console.error('Get Qna Categories API Error:', error);
    throw error;
  }
};
